import Vue from 'vue';

Vue.config.productionTip = false;

import App from '@/App';
import router from '@/router';
import store from '@/store';
import vars from '@/config/vars';
import PaymentNotificator from '@/services/PaymentNotificator';

// Cielo theme
import '@/assets/scss/theme.scss';

// Vue plugins
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import Clipboard from 'v-clipboard';
Vue.use(Clipboard);

import './multiLanguage';

import { initializeLogging, logException } from '@/helpers/cieloLogger';
initializeLogging(vars.GOOGLE_ANALYTICS_TRACKING_ID);

import isHeadlessBrowser from '@/helpers/isHeadless';

function loadDynaRUMScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = vars.DYNATRACE_SCRIPT_URL;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
}

function loadC2PEssentials() {
    // js
    const script = document.createElement('script');
    script.type = 'module';
    script.src = vars.C2P_MASTERCARD_UI_KIT_SCRIPT_URL;
    document.head.appendChild(script);

    // css
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.src = vars.C2P_MASTERCARD_UI_KIT_CSS_URL;
    document.head.appendChild(link);
}

//Filters
import './filters/capitalize';

// Error listener
Vue.config.errorHandler = logException;

// Vue initialization
new Vue({
    router,
    store,
    render: h => h(App),

    created: function () {
        loadDynaRUMScript();

        if(!isHeadlessBrowser()) {
            loadC2PEssentials();
        }
    },

    mounted: function () {
        store.state.mpi.multiLanguage = this.$ml;
    }
}).$mount('#app');

// Real time notifications
PaymentNotificator.CreateConnection();
